// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_container__iLHug {
    background-color: var(--global-main-color);
    width: 100%;
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/shop/components/footer/footer.module.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".container {\n    background-color: var(--global-main-color);\n    width: 100%;\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `footer_container__iLHug`
};
export default ___CSS_LOADER_EXPORT___;
